import React, { Component } from 'react';
import { Modal } from 'react-bootstrap';
import { translate } from 'react-i18next';
import FlatButton from 'material-ui/FlatButton';
import moment from 'moment';
var Config = require('../../../config');

class ModalDates extends Component{
	constructor(props, context) {
		super(props, context);
		this.handleShow = this.handleShow.bind(this);
        this.handleClose = this.handleClose.bind(this);
        this.handleChange=this.handleChange.bind(this);
        this.generate = this.generate.bind(this);
        this.dateCompare = this.dateCompare.bind(this);
		this.state = {
            show: false,
            start_date:moment().format('YYYY-MM-DD'),
            end_date:moment().format('YYYY-MM-DD'),
            id:"",
            name:""
		};
	}

	componentDidMount() {
		this.props.onRef(this);
	}
	componentWillUnmount() {
		this.props.onRef(null)
    }
    
    handleChange(e){
        this.setState({[e.target.name]: e.target.value});
    }

	handleClose() {
		this.setState({ show: false, id:"", name:""});
	}

	handleShow(id, name) {
		this.setState({ show: true, id:id, name:name});
	}

    generate(){
        if(this.dateCompare()){
            this.props.download(null, this.state.id, this.state.name, this.state.start_date, this.state.end_date);
            this.handleClose();
        }
    }

    dateCompare(){
		var ini = moment(this.state.start_date);
		var fin = moment(this.state.end_date);
		var date_ok = true;

		if(ini !== 'Invalid date' && fin !== 'Invalid date'){
			if(fin < ini){
				date_ok = false;
				document.getElementById('end_date').classList.add('error');
			}else{
				document.getElementById('end_date').classList.remove('error');
			}
		}else{
			date_ok = false;
		}		

		return date_ok;
    }
    
	render(){
		const { t } = this.props;
		
		return(
			<Modal bsSize="sm" show={this.state.show} onHide={this.handleClose}>
		       	<Modal.Header closeButton>
		        	<Modal.Title>{this.state.name}</Modal.Title>
		        </Modal.Header>
		        <Modal.Body >
		        	<div className="row" style={{padding:"0px 20px 0px 20px"}}>
				       <div className="col-xs-12">
                            <span className="span-min">Fecha inicial</span>
                            <input type="date" className="form-control input-sm" name="start_date" id="start_date"
                                value={this.state.start_date} onChange={(e)=>this.handleChange(e)} />
                       </div>
                       <div className="col-xs-12">
                            <span className="span-min">Fecha final</span>
                            <input type="date" className="form-control input-sm" name="end_date" id="end_date"
                                value={this.state.end_date} onChange={(e)=>this.handleChange(e)} />
                       </div>
				    </div>
		        </Modal.Body>
		        <Modal.Footer>
                    <FlatButton primary={true} label="Generar"  onClick={this.generate}/>
                    <FlatButton primary={true} label={t('content.generics.buttons.reset')}  onClick={this.handleClose}/>
		        </Modal.Footer>
	      	</Modal>
		);
	}
}

export default translate('translations')(ModalDates) 